import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import RecentActorsOutlinedIcon from "@mui/icons-material/RecentActorsOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import ImportExportOutlinedIcon from "@mui/icons-material/ImportExportOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import CarCrashOutlinedIcon from "@mui/icons-material/CarCrashOutlined";
import NoCrashOutlinedIcon from "@mui/icons-material/NoCrashOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import BikeScooterOutlinedIcon from "@mui/icons-material/BikeScooterOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import EuroSymbolOutlinedIcon from "@mui/icons-material/EuroSymbolOutlined";
import CreditScoreOutlinedIcon from "@mui/icons-material/CreditScoreOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import ConstructionIcon from "@mui/icons-material/Construction";
import CarRentalOutlinedIcon from "@mui/icons-material/CarRentalOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import DomainOutlinedIcon from "@mui/icons-material/DomainOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import { UserAuthMe } from "../services/credential/user";

export type CustomMenuItem = {
  text: string;
  path?: string;
  icon?: React.ElementType;
  items?: CustomMenuItem[];
  startsWithDivider?: boolean;
  requiredRole?: string; // Add role-based access
};

export const sidebarMenuItems: CustomMenuItem[] = [
  {
    text: "Noleggio",
    icon: CarRentalOutlinedIcon,
    items: [
      {
        text: "Preventivi",
        path: "/preventivi",
        icon: PostAddOutlinedIcon,
      },
      {
        text: "Contratti",
        path: "/contratti",
        icon: DescriptionOutlinedIcon,
      },
    ],
  },
  {
    text: "Anagrafica",
    icon: ContactMailOutlinedIcon,
    items: [
      { text: "Clienti", path: "/clienti", icon: PeopleAltOutlinedIcon },
      {
        text: "Monitoring Plus",
        path: "/monitoring-plus",
        icon: CreditScoreOutlinedIcon,
      },
      { text: "Mappa clienti", path: "/mappa-clienti", icon: MapOutlinedIcon },
      { text: "Filiali", path: "/filiali", icon: DomainOutlinedIcon },
      {
        text: "Riferimenti",
        path: "/riferimenti",
        icon: RecentActorsOutlinedIcon,
      },
      {
        text: "Utenti",
        path: "/utenti",
        icon: PersonOutlinedIcon,
        requiredRole: "admin",
      },
      {
        text: "Agenti",
        path: "/agenti",
        icon: BadgeOutlinedIcon,
      },
    ],
  },

  {
    text: "Parco",
    icon: LocalShippingOutlinedIcon,
    items: [
      {
        text: "Parco noleggio",
        path: "/parco-noleggio",
        icon: NoCrashOutlinedIcon,
      },
      {
        text: "Mezzi uso interno",
        path: "/mezzi-uso-interno",
        icon: DirectionsCarFilledOutlinedIcon,
      },
      {
        text: "Change Over",
        path: "/change-over",
        icon: CarCrashOutlinedIcon,
      },
      {
        text: "Raggruppamenti",
        path: "/raggruppamenti",
        icon: GroupsOutlinedIcon,
      },
      {
        text: "Tipi Macchina",
        path: "/categorie",
        icon: BikeScooterOutlinedIcon,
      },
      {
        text: "Collegamenti Macchine",
        path: "/collegamenti-macchine",
        icon: CarCrashOutlinedIcon,
      },
      {
        text: "Collegamenti Accessori",
        path: "/collegamenti-accessori",
        icon: ExtensionOutlinedIcon,
      },
      {
        text: "Collegamenti Voci Macchine",
        path: "/collegamenti-voci",
        icon: ExtensionOutlinedIcon,
      },
      {
        text: "Collegamenti Voci Tipi Macchina",
        path: "/collegamenti-voci-tipo-macchina",
        icon: ExtensionOutlinedIcon,
      },
      {
        text: "Voci Documento",
        path: "/voci-documento",
        icon: DescriptionOutlinedIcon,
      },
    ],
  },

  {
    text: "Assistenza",
    icon: SupportAgentOutlinedIcon,
    items: [
      {
        text: "Riparazioni",
        path: "/riparazioni",
        icon: ConstructionIcon,
      },
      {
        text: "Rapportini",
        path: "/assistenza-rapportini",
        icon: AssignmentOutlinedIcon,
      },
      {
        text: "Domande verbale",
        path: "/domande-verbale",
        icon: DescriptionOutlinedIcon,
      },
      {
        text: "Rapportini Fatti",
        path: "/rapportini-fatti",
        icon: FactCheckOutlinedIcon,
      },
      {
        text: "Preparazioni macchine",
        path: "/rapportini-da-fare",
        icon: PendingActionsOutlinedIcon,
      },
      {
        text: "Registro Gasolio",
        path: "/registro-gasolio",
        icon: LocalGasStationIcon,
      },
    ],
  },
  {
    text: "Manutenzioni",
    icon: ConstructionIcon,
    items: [
      {
        text: "Logistica",
        path: "/logistica",
        icon: ImportExportOutlinedIcon,
      },
    ],
  },
  {
    text: "Vendita",
    icon: EuroSymbolOutlinedIcon,
    items: [
      {
        text: "Registrazione Vendita",
        path: "/registrazione-vendita",
        icon: CreditScoreOutlinedIcon,
      },
    ],
  },
  {
    text: "Report",
    icon: AssessmentOutlinedIcon,
    items: [
      {
        text: "Report Silenti",
        path: "/report-silenti",
        icon: AssessmentOutlinedIcon,
      },
      {
        text: "Report Presenze",
        path: "/report-presenze",
        icon: AssessmentOutlinedIcon,
      },
      {
        text: "Report Giacenza",
        path: "/report-giacenza",
        icon: AssessmentOutlinedIcon,
      },
      {
        text: "Report Contratti",
        path: "/report-contratti",
        icon: AssessmentOutlinedIcon,
      },
    ],
  },
];

// Logout menu item - separated for fixed bottom positioning
export const logoutMenuItem: CustomMenuItem = {
  text: "Esci",
  icon: LogoutIcon,
};

// Helper function to check if user has required permissions

const hasPermission = (
  user: UserAuthMe | null,
  requiredRole?: string,
): boolean => {
  if (!requiredRole) return true;
  if (!user) return false;

  return (user.username === "erik" || user.username === "admin@hextra.it") && requiredRole === "admin";
};

const filterMenuByPermissions = (
  items: CustomMenuItem[],
  user: UserAuthMe | null,
): CustomMenuItem[] => {
  return items
    .filter((item) => hasPermission(user, item.requiredRole))
    .map((item) => ({
      ...item,
      items: item.items ? filterMenuByPermissions(item.items, user) : undefined,
    }));
};

export const getMenuItems = (user: UserAuthMe | null): CustomMenuItem[] => {
  return filterMenuByPermissions(sidebarMenuItems, user);
};
